/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI, URL_API } from "api";
import { PostDocumentsPayload, PostDocumentsResponse } from "api/documents/dtos/documents.dto";
import axios from "axios";


const ROTA = '/files';

class DocumentAPI {
    static async getByUUID(uuid: string) {
        const response = await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'GET', null);
        return response;
    }

    static async getByUUIDToDownload(uuid: string) {
        const response = await fetchAPI(`${URL_API}${ROTA}/${uuid}/download`, 'GET', null);
        return response;
    }

    static async upload(
        payload: PostDocumentsPayload,
    ): Promise<PostDocumentsResponse> {
        const formData = new FormData();

        formData.append('type', payload.documentInfo.type);
        formData.append('file', payload.file);

        const response = await axios.post<PostDocumentsResponse>(
            `${URL_API}${ROTA}`,
            formData,
            {
                headers: {
                    Accept: 'application/json',
                },
            },
        );
        return response.data;
    }

}



export default DocumentAPI;
